import { Collapse as CollapseAntd } from 'antd';
import styled from 'styled-components';
import color from '../../configs/color';

const Group = styled(CollapseAntd)`
  background-color: ${color.grey5};
  border-radius: 12px;
  overflow: hidden;
  border: ${(props) => {
    return props.bordered ? `1px solid ${color.grey1}` : 'none';
  }};

  .ant-collapse-header {
    padding: ${(props) => {
      const paddingHeader = props?.header_style?.padding;
      return paddingHeader ? `${paddingHeader} !important;` : '20px !important';
    }}
    display: flex;
    flex-wrap: nowrap;
  }

  .ant-collapse-content-box {
    padding-bottom: 20px !important;
  }

  .ant-collapse-icon-position-right
    > .ant-collapse-item
    > .ant-collapse-header {
    padding: 20px 40px 20px !important;
  }

  > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
    font-size: 16px !important;
    color: ${color.black3};
  }

  .row_hover {
    .ant-collapse-header:hover {
      background-color: ${color.grey3};
    }
  }

  &.content_box_padding_0 {
    .ant-collapse-content-box {
      padding: 0 !important;
    }
  }
`;

const Panel = styled(Group.Panel)``;

export default { Group, Panel };
